import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Wrapper from '../../../components/Wrapper';
import { CategoryCardV2 } from '../../../components/Cards';
import Typograpy from '../../../components/Typograpy';
import reports from '../../../services/reports';
import Spinner from '../../../components/Spinner';
import { makeReportAllgroups } from '../../../utils/makeReport';
import { Col, Row } from 'antd';
import RangePicker from '../../../components/RangePicker';

export default () => {
  const { selectedDate } = useSelector((state) => state.selectedDateReducer);
  const { categories, regions, groups, users } = useSelector(
    (state) => state.appReducer
  );
  const { regionId, groupId } = useSelector((state) => state.authReducer);
  const [active, setActive] = useState('groups');
  const [group, setgroup] = useState(undefined);
  const [groupReport, setgroupReport] = useState([]);
  const [onegroupReport, setOnegroupReport] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [filters, setFilters] = useState([]);
  const dispatch = useDispatch();
  const dateQuery = useMemo(
    () => selectedDate.every((item) => item !== '') && selectedDate,
    [selectedDate]
  );

  const [loading, setLoading] = useState(false);

  const handleActive = (item) => {
    if (item.value === 'all') {
      setgroup(undefined);
    } else {
      setgroup(item?.id);
    }
    setActive(item?.value);
  };

  // const fetchReportBygroups = async () => {
  //   try {
  //     setLoading(true);
  //     const data = {
  //       start: selectedDate[0],
  //       end: selectedDate[1],
  //       group: groupId,
  //     };

  //     const secId = groups.find((itm) => itm._id === groupId);
  //     const foo = regions.find((item) => item._id == regionId);
  //     setFilters([
  //       {
  //         id: secId?._id,
  //         title: secId?.title + 'лар',
  //         value: 'groups',
  //       },
  //       ...buttons,

  //       {
  //         id: secId?._id,
  //         title: secId?.title,
  //         value: 'group',
  //         region: foo?.title,
  //       },
  //     ]);
  //     const reportsData = await reports.getAllRegionsReport(data);
  //     const report = makeReportByOnegroup(reportsData, categories, regions);
  //     setgroupReport(report);
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.log(error);
  //   }
  // };
  const fetchAllReport = async () => {
    try {
      setLoading(true);
      const data = {
        start: selectedDate[0],
        end: selectedDate[1],
        region: regionId,
      };
      const reportsData = await reports.getAllgroupsReport(data);
      const report = makeReportAllgroups(reportsData, categories, groups);
      setgroupReport(report);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error.message);
    }
  };

  // const fetchOnegroupReport = async () => {
  //   try {
  //     setLoading(true);
  //     let today = moment(new Date()).format('YYYY-MM-DD');
  //     const data = {
  //       start: '2022-08-01',
  //       end: today,
  //       region: regionId,
  //       group: groupId,
  //     };

  //     const reportsData = await reports.getAllOnegroupReport(data);
  //     const report = makeReportOnegroup(reportsData);

  //     setOnegroupReport(report);
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    // if (active === 'all') {
    //   dispatch(hideRangePicker(true));

    //   fetchAllReport();
    // }
    // if (active === 'groups') {
    fetchAllReport();
    // dispatch(hideRangePicker(true));
    // }
    // if (active === 'group') {
    //   dispatch(hideRangePicker(false));
    //   fetchOnegroupReport();
    // }
  }, [dateQuery, groups, categories, regions, group]);

  // const elements = {
  //   all: (
  //     <>
  //       {reportData && reportData.length === 0 ? (
  //         <h2 style={{ textAlign: 'center', fontSize: '26px' }}>
  //           Танланган вақт кесими бўйича натижалар аниқланмади!
  //         </h2>
  //       ) : (
  //         <>
  //           <Typograpy>
  //             Туман (шаҳар) 4 та гуруҳ раҳбарлари томонидан соҳалар кесимида{' '}
  //             <br />
  //             режалаштирилган ва бажарилган ишлар таҳлили
  //           </Typograpy>
  //           <CategoryCardV2 pageType='main' data={reportData} />
  //         </>
  //       )}
  //     </>
  //   ),
  //   groups: (
  //     <>
  //       {groupReport && groupReport.length === 0 ? (
  //         <h2 style={{ textAlign: 'center', fontSize: '26px' }}>
  //           Танланган вақт кесими бўйича натижалар аниқланмади!
  //         </h2>
  //       ) : (
  //         <>
  //           <Typograpy>
  //             {filters[2]?.title + 'лар'} раҳбарлари томонидан соҳалар кесимида{' '}
  //             <br />
  //             режалаштирилган ва бажарилган ишлар таҳлили
  //           </Typograpy>
  //           <CategoryCardV2 pageType='user' data={groupReport} />
  //         </>
  //       )}
  //     </>
  //   ),
  //   group: (
  //     <>
  //       {onegroupReport && onegroupReport.length === 0 ? (
  //         <h2 style={{ textAlign: 'center', fontSize: '26px' }}>
  //           Танланган вақт кесими бўйича натижалар аниқланмади!
  //         </h2>
  //       ) : (
  //         <>
  //           <Typograpy>
  //             {filters[2]?.region + ' ' + filters[2]?.title} раҳбари томонидан
  //             соҳалар кесимида <br />
  //             режалаштирилган ва бажарилган ишлар таҳлили
  //           </Typograpy>
  //           <CategoryCardV2
  //             pageType='user'
  //             data={onegroupReport}
  //             hideGeneralIndicators={true}
  //           />
  //         </>
  //       )}
  //     </>
  //   ),
  // };

  if (loading) return <Spinner maxHeight='100%' />;

  return (
    <Wrapper>
      {/* <Filters list={filters} active={active} handleActive={handleActive} /> */}
      {groupReport && groupReport.length === 0 ? (
        <h2 style={{ textAlign: 'center', fontSize: '26px' }}>
          Танланган вақт кесими бўйича натижалар аниқланмади!
        </h2>
      ) : (
        <>
          <RangePicker />
          <Typograpy>
            Вилоятдаги барча гуруҳ раҳбарлари томонидан соҳалар кесимида <br />
            режалаштирилган ва бажарилган ишлар таҳлили
          </Typograpy>
          <Row align='middle' gutter={[20, 50]}>
            {groupReport &&
              groupReport?.map((item, indx) => (
                <Col
                  key={indx}
                  xs={24}
                  lg={12}
                  xl={12}
                  xxl={6}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <CategoryCardV2 pageType='main' item={item} />
                </Col>
              ))}
          </Row>
        </>
      )}
    </Wrapper>
  );
};
